module.exports = __webpack_public_path__ + "static/24-2de6f38e4a0afe2cc620d2e567cef778.jpg";